import { getRequest, postRequest } from "./fetchWrapper";

export const getDeceasedList = (agencyId, page, limit) => {
    const url = `/Template/${agencyId}/Last/${page}/${limit}/Deceased`;
    return getRequest(url);
}

export const getDeceasedInfos = (deceasedId) => {
    const url = `/Template/${deceasedId}/Deceased/Wall`;
    return getRequest(url);
}

export const getDeceasedCondolences = (deceasedId) => {
    const url = `/Template/${deceasedId}/Condoleances`;
    return getRequest(url);
}

export const postDeceasedCondolences = (data) => {
    const url = `/Template/Condoleances/Add`;
    return postRequest(url, data);
}

export const findDeceasedByName = (agencyId, deceasedName) => {
    const url = `/Template/${agencyId}/Find/${deceasedName}/0/Deceased`;
    return getRequest(url);
}